import { render } from "./CountByInterestCategoryListChart.vue?vue&type=template&id=188b4368&scoped=true"
import script from "./CountByInterestCategoryListChart.vue?vue&type=script&lang=js"
export * from "./CountByInterestCategoryListChart.vue?vue&type=script&lang=js"

import "./CountByInterestCategoryListChart.vue?vue&type=style&index=0&id=188b4368&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-188b4368"]])

export default __exports__